import { DiagramElement } from './diagram-element';
import { getContent } from '../../utility/dom-util';
import { templateCompiler } from '../../utility/base-util';
/**
 * HTMLElement defines the basic html elements
 */
export class DiagramHtmlElement extends DiagramElement {
    /**
     * set the id for each element \
     *
     * @returns { void }set the id for each element\
     * @param {string} nodeId - provide the x value.
     * @param {string} diagramId - provide the y value.
     * @param {string} annotationId - provide the id value.
     * @param {string} nodeTemplate - provide the id value.
     *
     * @private
     */
    constructor(nodeId, diagramId, annotationId, nodeTemplate) {
        super();
        this.data = '';
        /**
         * Gets the node id for the element
         */
        this.nodeId = '';
        /**
         * defines the id of the annotation on rendering template on label.
         * @private
         */
        this.annotationId = '';
        /**
         * Gets the diagram id for the html element
         */
        this.diagramId = '';
        this.diagramId = diagramId;
        this.nodeId = nodeId;
        this.annotationId = annotationId;
        this.templateFn = templateCompiler(nodeTemplate);
    }
    /**
     * getNodeTemplate method \
     *
     * @returns { Function } getNodeTemplate method .\
     *
     * @private
     */
    getNodeTemplate() {
        return this.templateFn;
    }
    /**
     * Gets or sets the geometry of the html element \
     *
     * @returns { string | HTMLElement } Gets or sets the geometry of the html element \
     *
     * @private
     */
    get content() {
        return this.data;
    }
    /**
     * Gets or sets the value of the html element \
     *
     * @returns { void }Gets or sets the value of the html element\
     * @param {string | HTMLElement} value - provide the value value.
     *
     * @private
     */
    set content(value) {
        this.data = value;
        if (!this.canReset) {
            this.canReset = true;
            if (!this.isTemplate) {
                this.template = getContent(this, true);
            }
            this.canReset = false;
            this.isDirt = true;
        }
    }
}
